<template>
	<div ref="popupContainer">
		<vx-card class="mb-1">
			<div class="vx-row mb-2">
				<div class="vx-col mb-2">
					<h3>Filtres :</h3>
				</div>
				<div class="vx-col px-1 mb-2">
					<vs-select
						v-model="commercialFilter"
						class="w-full select-large"
						label="Commercial"
						placeholder="Commercial"
						autocomplete
					>
						<vs-select-item
							key=""
							value=""
							text="Tous les commerciaux"
							class="w-full"
						/>
						<vs-select-item
							:key="index"
							:value="item.id"
							:text="item.firstname + ' ' + item.lastname"
							v-for="(item, index) in allCollaborators"
							class="w-full"
						/>
					</vs-select>
				</div>
				<div class="vx-col px-1 mb-2">
					<vs-input
						label="N° Contrat"
						class="inputx"
						placeholder="N° Contrat"
						v-model="contractNumberFilter"
						@input="notificationFilter()"
					/>
				</div>
				<div class="vx-col px-1 mb-2">
					<vs-input
						class="inputx"
						label="Client"
						placeholder="Client"
						v-model="societyFilter"
						@input="notificationFilter()"
					/>
				</div>

				<div class="vx-col px-1 mb-2">
					<vs-select
						v-model="typeFilter"
						class="w-full select-large"
						label="Type d'alerte (sélection multiple)"
						placeholder="Type d'alerte"
						autocomplete
						multiple
					>
						<vs-select-item
							:key="index"
							:value="item.id"
							:text="item.name"
							v-for="(item, index) in notifications_types"
							class="w-full"
						/>
					</vs-select>
				</div>

				<!-- <div class="vx-col px-1 mb-2">
					<vx-input-group class="w-full bottom">
						<label for="" class="vs-select--label">Période début</label>
						<flat-pickr
							class="w-full"
							v-model="startDateFilter"
							:config="configDatePicker"
						/>
					</vx-input-group>
				</div>

				<div class="vx-col mb-2">
					<vx-input-group class="w-full bottom">
						<label for="" class="vs-select--label">Période fin</label>
						<flat-pickr
							class="w-full"
							v-model="endDateFilter"
							:config="configDatePicker"
						/>
					</vx-input-group>
				</div> -->
				<div class="vx-col mb-2">
					<vs-select
						v-model="statusFilter"
						class="w-full select-large"
						label="Statut"
						placeholder="Statut de l'alerte"
						autocomplete
					>
						<vs-select-item value="" text="Tous les statuts" class="w-full" />
						<vs-select-item
							:key="index"
							:value="item.id"
							:text="item.text"
							v-for="(item, index) in notificationStatus"
							class="w-full"
						/>
					</vs-select>
				</div>
			</div>
			<div class="vx-row w-full mt-2">
				<div class="vx-col">
					<strong>Nombre de résultats : {{ list.length }}</strong>
				</div>
			</div>
		</vx-card>
		<vs-table :data="list" :key="commercialTableRefreshKey">
			<template slot="thead">
				<vs-th class="th-sticky pdl0">Client</vs-th>
				<vs-th class="th-sticky pdl0">Contrat N°</vs-th>
				<vs-th class="th-sticky pdl0">Commercial</vs-th>
				<vs-th class="th-sticky pdl0">Type d'alerte</vs-th>
				<!-- <vs-th class="th-sticky pdl0">Date de fin estimée</vs-th>-->
				<vs-th class="th-sticky pdl0">Action ?</vs-th>
			</template>

			<template slot-scope="{ data }">
				<vs-tr :key="index" v-for="(row, index) in data">
					<vs-td style="width: 15%"
						><span
							class="hvr-underline"
							@click="displaySocietyPopup(row.society_id)"
							><strong>{{ getSocietyName(row.society_id) }}</strong></span
						></vs-td
					>
					<vs-td style="width: 5%" class="text-center pdl0"
						><span
							@click="displayContractPopup(row.contract_id)"
							class="hvr-underline hvr-underline-out"
							>{{ row.contract_id }}</span
						></vs-td
					>
					<vs-td style="width: 5%" class="text-center pdl0">
						<vx-tooltip
							v-if="row.commercial_id"
							:text="getCollaboratorName(row.commercial_id)"
							position="top"
						>
							<vs-avatar
								style="border: 1px solid"
								:src="getCollaboratorAvatar(row.commercial_id)"
								:text="getCollaboratorName(row.commercial_id)"
							/>
						</vx-tooltip>
					</vs-td>
					<vs-td style="width: 45%">
						<vs-chip
							:key="indextd"
							v-for="(rowtd, indextd) in row.items"
							:color="getNotificationColor(rowtd.notification_type_id)"
							class="text-align-right mr-5"
						>
							<span class="my-2">
								{{
									getNotificationType(rowtd.notification_type_id).toString() +
									(rowtd.perform ? " - " + rowtd.perform : "")
								}}
							</span>
						</vs-chip>
					</vs-td>
					<!-- <vs-td style="width: 10%" v-else>{{
						getNotificationType(row.notification_type_id).toString()
					}}</vs-td>
					<vs-td style="width: 10%" class="text-center pdl0">{{
						row.estimated_end_date
							? row.estimated_end_date
									.substr(0, 10)
									.split("-")
									.reverse()
									.join("/")
							: ""
					}}</vs-td>
					 -->
					<vs-td style="width: 10%">
						<vs-button
							v-if="
								row.items.filter((ele) => ele.notification_checked == 0)
									.length > 0
							"
							color="warning"
							@click="updateNotification(row)"
							><vs-icon icon="error" size="medium"
						/></vs-button>
						<vs-button v-else color="success" @click="updateNotification(row)"
							><vs-icon icon="check" size="medium"
						/></vs-button>
					</vs-td>
				</vs-tr>
			</template>
		</vs-table>
	</div>
</template>

<script>
import Vue from "vue";
import VueCookies from "vue-cookies";
import dbFieldConvertor from "@/mixins/dbFieldConvertorMixin";
import utilsMixin from "@/mixins/utilsMixin";
import store from "@/store/store";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import monthSelect from "flatpickr/dist/plugins/monthSelect";
import "flatpickr/dist/plugins/monthSelect/style.css";
import ContractInfoPopup from "@/components/popups/ContractInfoPopup";
import SocietyInfoPopup from "@/components/popups/SocietyInfoPopup";

export default {
	name: "AlertesCommercialesTable",
	components: {
		flatPickr,
		ContractInfoPopup,
		SocietyInfoPopup,
		monthSelect,
	},
	props: {
		sortUserId: Boolean,
		allSocieties: Array,
		allCollaborators: Array,
		allCollaboratorsAvatar: Array,
	},
	mixins: [dbFieldConvertor, utilsMixin],
	computed: {
		relanceFilter: () => {
			return store.state.relanceFilter;
		},
		notifications: () => {
			return store.state.notifications;
		},
		notifications_types: () => {
			return store.state.notifications_types;
		},
		activeUser: () => {
			return VueCookies.get("userInfo");
		},
		allContractsWithContractsUsers: () => {
			return store.state.contracts_contracts_users;
		},
		societies: () => {
			return store.state.societies;
		},
		filterType: () => {
			return store.state.relanceFilter;
		},
	},
	data() {
		return {
			apiUrl: store.state.backendApiUrl,
			list: [],
			commercialTableRefreshKey: 0,
			resetFilter: null,
			commercialFilter: null,
			contractNumberFilter: null,
			societyFilter: null,
			typeFilter: [],
			showContractPopup: false,
			startDateFilter: null,
			statusFilter: "0",
			endDateFilter: null,
			notificationStatus: [
				{
					text: "A traiter",
					id: "0",
				},
				{
					text: "Traitée",
					id: "1",
				},
			],
			configDatePicker: {
				locale: require("flatpickr/dist/l10n/fr.js").default.fr,
				plugins: [
					new monthSelect({
						shorthand: true,
						dateFormat: "m/Y",
						altFormat: "m-Y",
						theme: "light",
					}),
				],
			},
			refreshKey: 0,
		};
	},
	created() {
		this.getAllNotifications();
		this.$store.dispatch("getAllNotificationsTypes");
		this.$store.dispatch("getAllContractsWithContractsUsers");
		this.$store.dispatch("getAllSocieties");

		/*
		 * let today = new Date(Date.now());
		 *  IF ACTIVE USER ID IS IN COMMERCIAL FILTER LIST SELECT
		 */
		//let foundCollaborator = this.allCollaborators.findIndex(row => row.id == this.activeUser.id);
		this.commercialFilter = this.relanceFilter.commercialFilter;
		this.endDateFilter = this.relanceFilter.endDateFilter;
		this.startDateFilter = this.relanceFilter.startDateFilter;
		this.typeFilter = this.relanceFilter.typeFilter;
		this.statusFilter = this.relanceFilter.statusFilter;
		/*
		 * if(foundCollaborator >= 0){
		 * 	//console.log("foundCollaborator", foundCollaborator);
		 * 	this.commercialFilter = this.activeUser.id;
		 * }
		 * if(this.$props.sortUserId){
		 * 	this.commercialFilter = this.activeUser.id;
		 * }
		 */

		/*
		 * this.endDateFilter = `${String(today.getMonth() + 1).padStart(2, "0")}/${today.getFullYear()}`;
		 * this.startDateFilter = `${String((today.getMonth() + 1 - 2) <= 0 ? 12 + (today.getMonth() + 1 - 2) : today.getMonth() + 1 - 2).padStart(2, "0")}/${(today.getMonth() + 1 - 2) <= 0 ? today.getFullYear() - 1 : today.getFullYear()}`;
		 */
		this.notificationFilter();
	},
	watch: {
		"$store.state.relanceFilter": async function (data) {
			this.commercialFilter = data.commercialFilter;
		},
		allCollaborators: async function (data) {
			let foundCollaborator = data.findIndex(
				(row) => row.id == this.activeUser.id
			);
			if (foundCollaborator >= 0) {
				//console.log("foundCollaborator", foundCollaborator);
				//this.commercialFilter = this.activeUser.id;
			}
			this.notificationFilter();
		},
		notifications: async function () {
			this.notificationFilter();
		},
		commercialFilter: async function (data) {
			this.$store.dispatch("updateRelanceFilter", {
				...this.relanceFilter,
				commercialFilter: data,
			});
			this.notificationFilter();
		},
		endDateFilter: async function (data) {
			this.$store.dispatch("updateRelanceFilter", {
				...this.relanceFilter,
				endDateFilter: data,
			});
			this.notificationFilter();
		},
		startDateFilter: async function (data) {
			this.$store.dispatch("updateRelanceFilter", {
				...this.relanceFilter,
				startDateFilter: data,
			});
			this.notificationFilter();
		},
		typeFilter: async function (data) {
			this.$store.dispatch("updateRelanceFilter", {
				...this.relanceFilter,
				typeFilter: data,
			});
			this.notificationFilter();
		},
		statusFilter: async function (data) {
			this.$store.dispatch("updateRelanceFilter", {
				...this.relanceFilter,
				statusFilter: data,
			});
			this.notificationFilter();
		},
	},
	methods: {
		getNotificationColor(id) {
			switch (id) {
				case 1:
					return "warning";
				case 2:
					return this.getContractStatusColor(8);
				case 3:
					return this.getContractStatusColor(9);
				case 5:
					return this.getContractStatusColor(3);
				case 6:
					return this.getContractStatusColor(3);
				default:
					return "primary";
			}
		},
		/**
		 * Show contract popup
		 */
		displayContractPopup(contract_id) {
			this.sotreFilter();
			let selectedContract = null;
			let foundContract = this.allContractsWithContractsUsers.findIndex(
				(row) => row.id == contract_id
			);
			if (foundContract < 0) {
				this.$vs.notify({
					title: "Erreur",
					text: "Contrat introuvable, contactez l'équipe technique.",
				});
				return false;
			}
			let account_manager_avatars = [];
			if (this.allContractsWithContractsUsers[foundContract].account_managers) {
				let contract_account_managers_names =
					this.allContractsWithContractsUsers[foundContract]
						.account_managers !== null
						? this.allContractsWithContractsUsers[
								foundContract
						  ].account_managers.split(", ")
						: [];
				let contract_account_managers = contract_account_managers_names.splice(
					0,
					contract_account_managers_names.length / 2
				);
				for (let i = 0; i < contract_account_managers.length; i++) {
					account_manager_avatars.push({
						name: contract_account_managers_names[i],
						users_id: contract_account_managers[i],
						is_lead:
							this.allContractsWithContractsUsers[foundContract].lead_am ==
							contract_account_managers[i]
								? 1
								: 0,
					});
				}
			}
			selectedContract = this.allContractsWithContractsUsers[foundContract];
			selectedContract.account_manager_avatars = account_manager_avatars;
			this.showContractPopup = true;

			//Instancie la class SocietyInfoPopup pour mount sur la balise div principale
			let ComponentClass = Vue.extend(ContractInfoPopup);
			let contractPopup = new ComponentClass({
				propsData: {
					contract: selectedContract,
					popupActive: this.showContractPopup,
					router: this.$router,
				},
			});
			// @modify-contract="modifyContract($event)"
			contractPopup.$mount();
			contractPopup.$on("modify-contract", (contractId) => {
				this.modifyContract(contractId);
			});
			contractPopup.$on("modify-missions", (contractId) => {
				this.modifyMissions(contractId);
			});

			//this.$refs.popupContainer.appendChild(contractPopup.$el);
		},
		sotreFilter() {
			this.resetFilter = {
				commercialFilter: this.commercialFilter,
				endDateFilter: this.endDateFilter,
				startDateFilter: this.startDateFilter,
				typeFilter: this.typeFilter,
				statusFilter: this.statusFilter,
			};
		},

		/**
		 * Show society popup
		 */
		displaySocietyPopup(societyId) {
			let selectedSociety = null; // Always reset data before assigning it
			selectedSociety = JSON.parse(
				JSON.stringify(
					this.societies.find((society) => society.id == societyId)
				)
			);
			this.$http
				.get(this.apiUrl + "society/getImg/" + societyId)
				.then((image) => {
					let imgObject = null;
					if (image.data.length > 0) {
						imgObject = image.data;
					}

					selectedSociety.image = imgObject;
				})
				.catch((err) => {
					//console.log(err);
				});

			//Instancie la class SocietyInfoPopup pour mount sur la balise div principale
			let ComponentClass = Vue.extend(SocietyInfoPopup);
			let societyPopup = new ComponentClass({
				propsData: {
					society: selectedSociety,
					popupActive: true,
					router: this.$router,
					apiUrl: this.apiUrl,
				},
			});
			societyPopup.$mount();
			societyPopup.$on("contract-info-popup", (contract) => {
				this.displayContractInfoPopup(contract);
			});
			societyPopup.$on("refresh-client", () => {
				this.getAllSocieties();
			});
			this.$refs.popupContainer.appendChild(societyPopup.$el);
		},

		/**
		 * Jump to updateContract page
		 */
		modifyContract(contractId) {
			this.showContractPopup = false;
			this.$router.push({
				name: "update_entity",
				params: {
					contractId: contractId,
					startIndex: 0,
					updateEntityForm: "contracts",
				},
			});
		},

		/**
		 * Jump to updateMission page
		 */
		modifyMissions(contractId) {
			this.showContractPopup = false;
			this.$router.push({
				name: "update_entity",
				params: {
					contractId: contractId,
					startIndex: 1,
					updateEntityForm: "contracts_missions",
				},
			});
		},

		/**
		 * Get all notifications
		 */
		getAllNotifications() {
			this.$store.dispatch("getAllNotifications");
		},

		/**
		 * Get a collaborator's name by @param {Number} userId - ID of this collaborator
		 * @return {String}
		 */
		getCollaboratorName(userId) {
			let foundCollaborator = this.allCollaborators.find(
				(collaborator) => collaborator.id == userId
			);
			if (foundCollaborator)
				return foundCollaborator.firstname + " " + foundCollaborator.lastname;
			else return null;
		},

		/**
		 * Get a collaborator's avatar by @param {Number} userId - ID of this collaborator
		 * @return {String}
		 */
		getCollaboratorAvatar(userId) {
			let foundAvatar = this.allCollaboratorsAvatar.find(
				(avatar) => avatar.id == userId
			);
			if (foundAvatar) return foundAvatar.avatar;
			else return null;
		},

		/**
		 * Get a type's name for a notification
		 * @param {Number} nb - type's ID of this notification
		 * @return {String}
		 */
		getNotificationType(nb) {
			let thisType = this.notifications_types.filter((type) => type.id == nb);
			if (thisType.length > 0) return thisType[0].name.replace("Relance ", "");
			else return "Type d'alerte inconnu";
		},

		/**
		 * Get a society's name for a notification
		 * @param {Number} societyId - society's ID of this notification
		 * @return {String}
		 */
		getSocietyName(societyId) {
			if (
				this.$props.allSocieties.filter((society) => society.id == societyId)
					.length > 0
			) {
				return this.$props.allSocieties.filter(
					(society) => society.id == societyId
				)[0].name;
			}
			return "Entreprise non renseignée";
		},

		/**
		 * Get value of "input_required" for a notification
		 * @param {Number} id - notification type ID of this notification
		 * @return {Number}
		 */
		isInputRequired(id) {
			return this.notifications_types.filter((type) => type.id == id)[0]
				.input_required;
		},

		/**
		 * Notification Filter
		 */
		notificationFilter() {
			let result = this.notifications;
			// notes = result.filter((n) => n.notification_type_id == 4);
			// result = result.filter((n) => n.notification_type_id != 4);

			// //console.log("NOTIFICATION LIST ", result.length);
			this.commercialFilter = this.$store.state.relanceFilter.commercialFilter;
			if (this.commercialFilter)
				result = result.filter((n) => n.commercial_id == this.commercialFilter);
			//notes
			// if (this.commercialFilter)
			// 	notes = notes.filter((n) => n.commercial_id == this.commercialFilter);
			if (this.typeFilter.length > 0)
				result = result
					.map((contract) => {
						// Filter items within each contract to match `notification_checked`
						const filteredItems = contract.items.filter((item) =>
							String(item.notification_type_id).includes(
								String(this.typeFilter)
							)
						);
						// Return contract only if it has matching items
						return filteredItems.length > 0
							? { ...contract, items: filteredItems }
							: null;
					})
					.filter((contract) => contract !== null);
			if (this.societyFilter) {
				let tmpSocieties = this.$props.allSocieties.filter((society) =>
					society.name.toLowerCase().includes(this.societyFilter.toLowerCase())
				);
				if (tmpSocieties.length > 0) {
					tmpSocieties = tmpSocieties.map((society) => {
						return society.id;
					});
					result = result.filter((n) => tmpSocieties.includes(n.society_id));
				}
			}
			if (this.contractNumberFilter)
				result = result.filter((n) =>
					String(n.contract_id).includes(this.contractNumberFilter)
				);
			// if (this.contractNumberFilter)
			// 	notes = notes.filter((n) =>
			// 		String(n.contract_id).includes(this.contractNumberFilter)
			// 	);
			// if (this.startDateFilter)
			// 	result = result.filter(
			// 		(n) =>
			// 			Number(n.estimated_end_date.substr(0, 7).replace("-", "")) >=
			// 			Number(this.startDateFilter.split("/").reverse().join(""))
			// 	);
			// if (this.endDateFilter)
			// 	result = result.filter(
			// 		(n) =>
			// 			Number(n.estimated_end_date.substr(0, 7).replace("-", "")) <=
			// 			Number(this.endDateFilter.split("/").reverse().join(""))
			// 	);
			if (this.statusFilter)
				result = result
					.map((contract) => {
						// Filter items within each contract to match `notification_checked`
						const filteredItems = contract.items.filter((item) =>
							String(item.notification_checked).includes(
								String(this.statusFilter)
							)
						);
						// Return contract only if it has matching items
						return filteredItems.length > 0
							? { ...contract, items: filteredItems }
							: null;
					})
					.filter((contract) => contract !== null);

			this.list = result;
			this.commercialTableRefreshKey++;
		},

		/**
		 * Update a notification
		 * @param {Object} item - all informations of this notification
		 */
		async updateNotification(row) {
			let types = row.items.map((item) => item.notification_type_id);
			/*
			 * //console.log("updateNotification", this.isInputRequired(row.notification_type_id) == 1, row.notification_checked == 0, row.additional_field == "");
			 * if(this.isInputRequired(row.notification_type_id) == 1 && row.notification_checked == 0 && !row.additional_field){
			 * 	this.$vs.notify({
			 * 		title: "Echec",
			 * 		text: "Veuillez remplir le champ additionnel pour valider l'alerte."
			 * 	});
			 * 	return false;
			 * }
			 */
			let hasOverlap = types.some((item) => [2, 3, 6].includes(item));
			if (hasOverlap) {
				this.displayContractPopup(row.contract_id);
			} else {
				//console.log("IDD", row);
				let url = "notifications/commercial/update";
				row.notification_checked = row.notification_checked == 1 ? 0 : 1;
				url = row.notification_type_id == 4 ? "contract/note/check" : url;
				let body =
					row.notification_type_id != 4
						? {
								commercial_notification: {
									id: row.id,
									society_id: row.society_id,
									contract_id: row.contract_id,
									mission_id: row.mission_id,
									commercial_id: row.commercial_id,
									engagement_duration: row.engagement_duration,
									early_cancellation_duration: row.early_cancellation_duration,
									missions_start_period: row.missions_start_period
										? row.missions_start_period.replace(/T|Z/g, " ")
										: null,
									estimated_end_date: row.estimated_end_date
										? row.estimated_end_date.replace(/T|Z/g, " ")
										: null,
									notification_type_id: row.notification_type_id,
									notification_checked: row.notification_checked,
									additional_field: row.additional_field,
								},
						  }
						: {
								notification_checked: row.notification_checked,
								id: row.id,
						  };
				//console.log("BODYYY", body);
				await this.$http.post(this.apiUrl + url, body).then((res) => {
					// //console.log("Update notification:", res.data);
					let commentary =
						row.notification_checked == 0
							? "Relance: de 'Traitée' à 'A traitée'"
							: "Relance: de 'A traitée' à 'Traitée'";

					this.$http
						.post(this.apiUrl + "logger/contract/add/" + row.contract_id, {
							action_id: 1,
							mission_id: row.mission_id,
							users_id: this.activeUser.id,
							comment: row.additional_field
								? `${commentary} : ${row.additional_field}`
								: commentary,
						})
						.then(() => {
							this.$vs.notify({
								title: "Succès",
								text: "Relance mise à jour.",
							});
							this.$emit("refresh-counter");
							// //console.log("Update notification:", res.data);
						});
				});
			}
		},
	},
};
</script>

<style>
</style>
